var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('Header',{attrs:{"title":"Il Progetto"}}),_c('iframe',{staticClass:"iframe",attrs:{"src":"https://unodiunmilione.com/it/pages/app-progetto"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }